import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CompanyService from "../../../../services/catalogs/CompanyService";

export const REQUEST_UPDATE_COMPANY = "REQUEST_UPDATE_COMPANY";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_ERROR = "UPDATE_COMPANY_ERROR";

function requestUpdateCompany() {
  return {
    type: REQUEST_UPDATE_COMPANY,
  };
}

function updateCompanySuccess(json) {
  return {
    type: UPDATE_COMPANY_SUCCESS,
    message: json.data,
  };
}

function updateCompanyError(json) {
  return {
    type: UPDATE_COMPANY_ERROR,
    error: json.data,
  };
}

export function updateCompany(company_id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateCompany());
    return CompanyService.putCompany(company_id, payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(updateCompanySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(updateCompany(company_id, payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(updateCompanyError(json.data));
      }
    });
  };
}
